import { instance } from "apis/interceptor";
import { google } from "googleapis";
import { TBuilding } from "types/building.types";
type ResponseType<T> = {
  success: boolean;
  message?: string;
  data?: T;
};

//TODO: 나중에 도메인에 맞게 수정 필요
export type TMeetingRoom = {
  id: string;
  name: string;
  capacity: number;
  description: string;
  isInsideTabletUsed: boolean;
  isOutsideTabletUsed: boolean;
  isBlocked: boolean;
  building?: {
    id: string;
    name: string;
    provider: "MILE" | "GOOGLE";
  };
  floor?: {
    id: string;
    name: string;
  };
  image: string;
  meetingRoomIntegration?: {
    id: string;
    integrationProvider: "GOOGLE" | "MILE";
    resourceName: string;
    capacity: number;
    description: string;
    privateMeetingDataCollected: boolean;
  };
  attendeeLimits?: TAttendeeLimit[];
};

export type TGoogleMeetingRoom = {
  resourceId: string;
  resourceName: string;
  resourceEmail: string;
  capacity: number;
  description: string;
  buildingId: string;
  floorName: string;
};

type TMeetingRoomPagination = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  meetingRoomList: TMeetingRoom[];
};

type TConnectionGoogleMeetingRoom = {
  connect: TGoogleMeetingRoom[];
  disconnet: TGoogleMeetingRoom[];
};

export type TLocationFilter = {
  name: string;
  id: string;
  provider?: "MILE" | "GOOGLE";
  floors?: ({
    id: string;
    name: string;
  } | null)[];
} | null;

export type TAttendeeLimit = {
  id: string;
  startTime: string;
  endTime: string;
  minAttendeeNum: number;
};

//INFO: (new) 회의실 추가하는 api
//TODO: image 값이 반드시 ""이어야 하는지 확인 필요
export const addMeetingRoom = async (
  name: string,
  capacity: number,
  isInsideTabletUsed: boolean,
  isOutsideTabletUsed: boolean,
  buildingId: string,
  floorId: string,
  description?: string,
  image?: string
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/meetings/meeting-room/by-mile", {
      name: name,
      capacity: capacity,
      description: description,
      isInsideTabletUsed: isInsideTabletUsed,
      isOutsideTabletUsed: isOutsideTabletUsed,
      buildingId: buildingId,
      floorId: floorId,
      image: image ?? "",
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "회의실을 생성할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 회의실 리스트를 가져오는 api
export const getMeetingRoomList = async (
  nowPageNumber: number,
  locationFilter?: TLocationFilter[],
  meetingRoomIdList?: string[],
  numberOfContents?: number,
  withBlocked?: boolean,
  attendeeLimitFilter?: "ALL" | "SET" | "NOT_SET"
): Promise<ResponseType<TMeetingRoomPagination>> => {
  try {
    const data = {
      nowPageNumber: nowPageNumber,
      locationFilter: locationFilter,
      meetingRoomIdList: meetingRoomIdList?.filter((id) => id !== ""),
      numberOfContents: numberOfContents ?? 6,
      withBlocked: withBlocked ?? false,
      attendeeLimitFilter: attendeeLimitFilter ?? "ALL",
    };

    const res = await instance.post("/meetings/meeting-room/list", {
      nowPageNumber: nowPageNumber,
      locationFilter: locationFilter,
      meetingRoomIdList: meetingRoomIdList?.filter((id) => id !== ""),
      numberOfContents: numberOfContents ?? 6,
      withBlocked: withBlocked ?? false,
      attendeeLimitFilter: attendeeLimitFilter ?? "ALL",
    });

    return { success: true, data: res.data };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "회의실 리스트를 가져올 수 없습니다." };
  }
};

//INFO: (new) google calendar로 회의실 만드는 api
export const createGoogleMeetingRoom = async (
  googleRefreshToken: string,
  privateMeetingDataCollected: boolean,
  googleResourceList: TGoogleMeetingRoom[]
) => {
  try {
    const res = await instance.post("/meetings/meeting-room/by-google", {
      googleRefreshToken: googleRefreshToken,
      privateMeetingDataCollected: privateMeetingDataCollected,
      googleResourceList: googleResourceList,
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    return { success: false, message: "회의실을 생성할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) google calendar로 연동된 회의실 리스트를 가져오는 api
export const getConnectedGoogleMeetingRoomList = async (
  calendarList: TGoogleMeetingRoom[]
): Promise<ResponseType<TConnectionGoogleMeetingRoom>> => {
  try {
    const res = await instance.post("/meetings/meeting-room/by-google/check-connection", {
      googleResourceList: calendarList,
    });
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: "회의실 리스트를 가져올 수 없습니다." };
  }
};

//INFO: (new) 회의실 삭제하는 api
export const deleteMeetingRoom = async (id: string): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.delete(`/meetings/meeting-room`, {
      data: {
        id: id,
      },
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "회의실을 삭제할 수 있는 권한이 없습니다." };
    } else return { success: false, message: "회의실을 삭제할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) Mile 회의실 수정하는 api
export const editMeetingRoom = async (
  id: string,
  name: string,
  capacity: number,
  isInsideTabletUsed: boolean,
  isOutsideTabletUsed: boolean,
  buildingId: string,
  floorId: string,
  description?: string,
  image?: string
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meetings/meeting-room/by-mile", {
      name: name,
      capacity: capacity,
      description: description,
      isInsideTabletUsed: isInsideTabletUsed,
      isOutsideTabletUsed: isOutsideTabletUsed,
      buildingId: buildingId,
      floorId: floorId,
      image: image ?? "",
      id: id,
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "회의실을 수정할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) Google 회의실 수정하는 api
export const editGoogleMeetingRoom = async (
  id: string,
  isInsideTabletUsed: boolean,
  isOutsideTabletUsed: boolean,
  privateMeetingDataCollected: boolean,
  image?: string
) => {
  try {
    const res = await instance.patch("/meetings/meeting-room/by-google", {
      id: id,
      isInsideTabletUsed: isInsideTabletUsed,
      isOutsideTabletUsed: isOutsideTabletUsed,
      image: image,
      privateMeetingDataCollected: privateMeetingDataCollected,
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    return { success: false, message: "회의실을 수정할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) Google 회의실 연동 해제하는 api
export const disconnectGoogleMeetingRoom = async (id: string) => {
  try {
    const res = await instance.patch(`/meetings/meeting-room/by-google/disconnect`, {
      id: id,
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "회의실 연동 해제할 수 있는 권한이 아닙니다. " };
    } else return { success: false, message: "회의실 연동을 해제할 수 없습니다. 다시 시도해주세요." };
  }
};

//INFO: (new) 건물 및 층을 조회하는 api (설정되지 않은 건물/층도 모두 보여줌)
export const getBuildingList = async (): Promise<ResponseType<(TBuilding | null)[]>> => {
  try {
    const res = await instance.get("/resources/building-floor/list");

    return { success: true, data: res.data };
  } catch (e: any) {
    const status = e.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    }
    return { success: false, message: "권한이 없습니다." };
  }
};

//INFO: (new) 건물 및 층을 조회하는 api
export const getBuildingListForLocation = async (): Promise<ResponseType<(TBuilding | null)[]>> => {
  try {
    const res = await instance.post("/meetings/meeting-room/resource");

    return { success: true, data: res.data };
  } catch (e: any) {
    const status = e.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    }
    return { success: false, message: "권한이 없습니다." };
  }
};

//INFO: (new) 회의실 최소 참석 인원 수정하는 api
export const editMeetingRoomMinAttendee = async (
  id: string,
  attendeeLimits: TAttendeeLimit[]
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meetings/meeting-room/min-attendee", {
      minAttendeeLimitList: attendeeLimits,
      meetingRoomId: id,
    });
    return { success: true, data: res.data.result };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "최소 참석 인원을 수정할 수 없습니다. 다시 시도해주세요." };
  }
};
